/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const BillingsRouter = {
  path: '/admin/billings',
  component: Layout,
  redirect: '/admin/billings/main/list',
  name: 'BillingManager',
  meta: {
    title: '帳務管理',
    icon: 'peoples',
    permissions: ['billing-manager-view']
  },
  children: [
    {
      path: 'credit',
      component: () => import('@/views/billings/credit/list'),
      name: 'CreditList',
      meta: {
        title: '會員點數清冊',
        icon: 'list',
        permissions: ['billing-credit-list-view']
      }
    },
    {
      path: 'finish',
      component: () => import('@/views/billings/finish/list'),
      name: 'FinishList',
      meta: {
        title: '完課清單',
        icon: 'list',
        permissions: ['billing-finish-list-view']
      }
    },
    {
      path: 'counts',
      component: () => import('@/views/billings/counts/list'),
      name: 'CountsList',
      meta: {
        title: '老師應付彙總',
        icon: 'list',
        permissions: ['billing-counts-list-view']
      }
    }
  ]
}
export default BillingsRouter
